import React from "react";
import {CFValue} from 'module/CustomField/type/CFType'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {AdaptCFValueInputComponent} from 'module/CustomField/component/input/AdaptCFValueInputComponent'
import {transformFromVerboseString, transformToVerboseString} from 'module/CustomField/util/VerboseStringUtil'

function adaptValueToView(value: CFValue): string {
	return !value && value !== 0 ? '' : transformToVerboseString(value + '')
}

function adaptValueToModel(viewValue: string) {
	return viewValue === '' ? null : transformFromVerboseString(viewValue)
}

export function CustomFieldVerboseInputComponent(props: CFComponentProps<CFValue>) {
	return (<div className={'CustomFieldVerboseInputComponent'}>
		<AdaptCFValueInputComponent {...props} adaptValueToView={adaptValueToView} adaptValueToModel={adaptValueToModel}/>
	</div>)
}